/**
 * phoneMetrics — ONE size for every phone in the studio's strip.
 *
 * The strip shows the live preview, the focused module's top-down view and one
 * card per connection. They only read as one row if they are the same size, so
 * the page size and the scale live here rather than in each file, and every
 * card renders a 390×844 page at exactly `PHONE_SCALE` — a constant, never a
 * measured fit, so the geometry is true from the first paint (the focus wire
 * anchors to boxes inside these frames).
 */

export const PHONE_W = 390;
export const PHONE_H = 844;
// 0.558 = 0.62 × 0.9 — the phone (and every card sized off it) is 10% smaller
// than before, in both dimensions, so it keeps a true phone shape.
export const PHONE_SCALE = 0.558;

/** The rendered screen — the size of every card's frame. */
export const SCREEN_W = Math.round(PHONE_W * PHONE_SCALE);
export const SCREEN_H = Math.round(PHONE_H * PHONE_SCALE);

/**
 * Extra blank column BETWEEN zones (preview ↔ focus ↔ connections). The cards
 * are deliberately identical, so grouping can only come from whitespace: cards
 * inside the connections run keep the strip's normal gap, and the three zones
 * are set apart by this much more. Whitespace, not a divider — the cards stay
 * the only furniture.
 */
export const ZONE_GAP = 28;

/**
 * The band above the cards that carries the zone titles (Preview · Data · Focus
 * · Connections). EVERY strip item reserves it, labelled or not — the frames
 * have to stay on one baseline or the wires, which anchor to boxes inside them,
 * would be measured against a row that steps.
 */
export const ZONE_LABEL_H = 22;
